import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import VideoSection from "./components/VideoSection";
import FeaturedProjects from "./components/FeaturedProjects";
import BlogSection from "./pages/BlogSection";
import ClientLogos from "./components/ClientLogos";
import ClientTestimonials from "./components/ClientTestimonials";
import Footer from "./components/Footer";
import AwardsRecognition from "./components/AwardsRecognition";
import ArchitecturalDesign from "./pages/ArchitecturalDesign";
import InteriorDesign from "./pages/InteriorDesign";
import ResidentialDesign from "./pages/ResidentialDesign";
import ProjectManagementConsultancy from "./pages/ProjectManagementConsultancy";
import About from "./pages/About";
import "@fontsource/montserrat";
import "@fontsource/merriweather";
import "./index.css";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import EditBlog from "./pages/EditBlog";
import CareerPage from "./pages/CareerPage";
import MiniAdmin from "./pages/MiniAdmin";
import AdminCareerPanel from "./pages/AdminCareerPanel";
import UploadHeroImage from "./pages/UploadHeroImage";
import AdminAwards from "./pages/AdminAwards";
import ClientLogoAdmin from "./pages/ClientLogoAdmin";
import AdminBlog from "./pages/AdminBlog";
import Teams from "./pages/Team";
import TeamAdmin from "./pages/AdminTeam";
import InteriorAdmin from "./pages/InteriorAdminPanel";
import ResidentailAdmin from "./pages/ResidentialAdminPanel";
import ArchitecturalAdmin from "./pages/ArchitecturalAdminPanel";
import AdminContact from "./pages/ContactAdmin";
import AdminInquiryPanel from "./pages/AdminInquiryPanel";
import Collaborations from "./pages/Collaborations";
import BlogDetailPage from "./pages/Blogdetailpage";
const Home = () => (
  <>
    <VideoSection />
    <AwardsRecognition />
    <FeaturedProjects />
    <ClientLogos />
    <ClientTestimonials />
    <Footer />
  </>
);

function App() {
  const token = localStorage.getItem("token");
  const location = useLocation();

  // Pages where Navbar should be hidden
  const hideNavbarRoutes = [
    "/blog-admin",
    "/edit",
    "/mini-admin",
    "/login",
    "/architectural-upload",
    "/awards-admin",
    "/client-logo-admin",
    "/team-admin",
    "/interior-admin",
    "/contact-admin",
    "/inquiry-admin",
  ];

  // Check if current route starts with any of the hideNavbarRoutes
  const shouldHideNavbar = hideNavbarRoutes.some((path) =>
    location.pathname.startsWith(path),
  );

  return (
    <div className="font-sans bg-beige text-dark">
      {!shouldHideNavbar && <Navbar />}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/architectural-design" element={<ArchitecturalDesign />} />
        <Route path="/about" element={<About />} />
        <Route path="/blogs" element={<BlogSection />} />
        <Route path="/blogs/:slugId" element={<BlogDetailPage />} />
        <Route path="/interior-design" element={<InteriorDesign />} />
        <Route path="/residential-design" element={<ResidentialDesign />} />
        <Route path="/team" element={<Teams />} />
        <Route path="/collaborations" element={<Collaborations />} />
        {/* <Route path="/admin2" element={<AdminCareerPanel />} /> */}
        <Route path="/architectural-upload" element={<UploadHeroImage />} />
        <Route
          path="/project-management-consultancy"
          element={<ProjectManagementConsultancy />}
        />
        <Route path="/careers" element={<CareerPage />} />

        {/* Protected Mini Admin */}
        <Route
          path="/mini-admin"
          element={token ? <MiniAdmin /> : <Navigate to="/login" />}
        />
        <Route
          path="/admin2"
          element={token ? <AdminCareerPanel /> : <Navigate to="/login" />}
        />
        <Route
          path="/admin"
          element={token ? <AdminDashboard /> : <Navigate to="/login" />}
        />
        {/* <Route
          path="/architectural-upload"
          element={token ? <UploadHeroImage /> : <Navigate to="/login" />}
        /> */}
        <Route
          path="/edit/:id"
          element={token ? <EditBlog /> : <Navigate to="/login" />}
        />
        <Route
          path="/awards-admin"
          element={token ? <AdminAwards /> : <Navigate to="/login" />}
        />
        <Route
          path="/client-logo-admin"
          element={token ? <ClientLogoAdmin /> : <Navigate to="/login" />}
        />
        <Route
          path="/blog-admin"
          element={token ? <AdminBlog /> : <Navigate to="/login" />}
        />
        <Route
          path="/team-admin"
          element={token ? <TeamAdmin /> : <Navigate to="/login" />}
        />
        <Route
          path="/interior-admin"
          element={token ? <InteriorAdmin /> : <Navigate to="/login" />}
        />
        <Route
          path="/residential-admin"
          element={token ? <ResidentailAdmin /> : <Navigate to="/login" />}
        />
        <Route
          path="/architectural-admin"
          element={token ? <ArchitecturalAdmin /> : <Navigate to="/login" />}
        />
        <Route
          path="/contact-admin"
          element={token ? <AdminContact /> : <Navigate to="/login" />}
        />
        <Route
          path="/inquiry-admin"
          element={token ? <AdminInquiryPanel /> : <Navigate to="/login" />}
        />
      </Routes>
    </div>
  );
}

export default App;
